import React from 'react'
import large1 from '../../assets/images/services/large/01.jpg'
import HeroSection4 from '../../Components/heroSection/HeroSection4'
import BlogSection2 from '../../Components/blogSection/BlogSection2'

const UiUxExperience = () => {
  return (
    <>
      <HeroSection4 name={"UI/UX Experience"} name2={"Home"} />
      <BlogSection2 bgImage={large1} selected={1} />
    </>
  )
}

export default UiUxExperience